// extracted by mini-css-extract-plugin
module.exports = {"left":"LeftSide_left__3pv1n"};